import * as actionTypes from "../../actions/blog/actionTypes";

const INITIAL_STATE = {
  blogs: {
    get: {
      loading: false,
      reset: false,
      success: {
        ok: false,
        data: [],
      },
      failure: {
        error: false,
        message: "",
      },
    },
  },
  topBlogs: {
    get: {
      loading: false,
      reset: false,
      success: {
        ok: false,
        data: [],
      },
      failure: {
        error: false,
        message: "",
      },
    },
  },
  comments: {
    get: {
      loading: false,
      reset: false,
      success: {
        ok: false,
        data: null,
      },
      failure: {
        error: false,
        message: "",
      },
    },
  },
  blogPost: {
    get: {
      loading: false,
      reset: false,
      success: {
        ok: false,
        data: {},
      },
      failure: {
        error: false,
        message: "",
      },
    },
  },
  relatedBlogPosts: {
    get: {
      loading: false,
      reset: false,
      success: {
        ok: false,
        data: [],
      },
      failure: {
        error: false,
        message: "",
      },
    },
  },
  latestBlogPosts: {
    get: {
      loading: false,
      reset: false,
      success: {
        ok: false,
        data: [],
      },
      failure: {
        error: false,
        message: "",
      },
    },
  },
};

const blogReducers = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.GET_BLOG_POSTS_LOADING:
      return {
        ...state,
        blogs: {
          ...state.blogs,
          get: {
            ...state.blogs.get,
            loading: true,
            reset: false,
            success: {
              ...state.blogs.get.success,
              ok: false,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case actionTypes.GET_BLOG_POSTS_SUCCESS:
      return {
        ...state,
        blogs: {
          ...state.blogs,
          get: {
            ...state.blogs.get,
            loading: false,
            reset: false,
            success: {
              ...state.blogs.get.success,
              ok: true,
              data: action.payload,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case actionTypes.GET_BLOG_POSTS_FAIL:
      return {
        ...state,
        blogs: {
          ...state.blogs,
          get: {
            ...state.blogs.get,
            loading: false,
            reset: false,
            success: {
              ...state.blogs.get.success,
              ok: false,
              data: null,
            },
            failure: {
              error: true,
              message: action.payload.message,
              accessDenied: action.payload.accessDenied,
            },
          },
        },
      };
    case actionTypes.GET_BLOG_POSTS_RESET:
      return {
        ...state,
        blogs: {
          ...state.blogs.get,
          get: {
            ...INITIAL_STATE.blogs.get,
            reset: true,
          },
        },
      };
    case actionTypes.GET_BLOG_POSTS_BY_CATEGORY_LOADING:
      return {
        ...state,
        blogs: {
          ...state.blogs,
          get: {
            ...state.blogs.get,
            loading: true,
            reset: false,
            success: {
              ...state.blogs.get.success,
              ok: false,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case actionTypes.GET_BLOG_POSTS_BY_CATEGORY_SUCCESS:
      return {
        ...state,
        blogs: {
          ...state.blogs,
          get: {
            ...state.blogs.get,
            loading: false,
            reset: false,
            success: {
              ...state.blogs.get.success,
              ok: true,
              data: action.payload,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case actionTypes.GET_BLOG_POSTS_BY_CATEGORY_FAIL:
      return {
        ...state,
        blogs: {
          ...state.blogs,
          get: {
            ...state.blogs.get,
            loading: false,
            reset: false,
            success: {
              ...state.blogs.get.success,
              ok: false,
              data: null,
            },
            failure: {
              error: true,
              message: action.payload.message,
              accessDenied: action.payload.accessDenied,
            },
          },
        },
      };
    case actionTypes.GET_BLOG_POSTS_BY_CATEGORY_RESET:
      return {
        ...state,
        blogs: {
          ...state.blogs.get,
          get: {
            ...INITIAL_STATE.blogs.get,
            reset: true,
          },
        },
      };
    case actionTypes.GET_TOP_BLOG_POSTS_THIS_MONTH_LOADING:
      return {
        ...state,
        topBlogs: {
          ...state.topBlogs,
          get: {
            ...state.topBlogs.get,
            loading: true,
            reset: false,
            success: {
              ...state.topBlogs.get.success,
              ok: false,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case actionTypes.GET_TOP_BLOG_POSTS_THIS_MONTH_SUCCESS:
      return {
        ...state,
        topBlogs: {
          ...state.topBlogs,
          get: {
            ...state.topBlogs.get,
            loading: false,
            reset: false,
            success: {
              ...state.topBlogs.get.success,
              ok: true,
              data: action.payload,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case actionTypes.GET_TOP_BLOG_POSTS_THIS_MONTH_FAIL:
      return {
        ...state,
        topBlogs: {
          ...state.topBlogs,
          get: {
            ...state.topBlogs.get,
            loading: false,
            reset: false,
            success: {
              ...state.topBlogs.get.success,
              ok: false,
              data: null,
            },
            failure: {
              error: true,
              message: action.payload.message,
              accessDenied: action.payload.accessDenied,
            },
          },
        },
      };
    case actionTypes.GET_TOP_BLOG_POSTS_THIS_MONTH_RESET:
      return {
        ...state,
        topBlogs: {
          ...state.topBlogs.get,
          get: {
            ...INITIAL_STATE.topBlogs.get,
            reset: true,
          },
        },
      };
    case actionTypes.GET_BLOG_POST_LOADING:
      return {
        ...state,
        blogPost: {
          ...state.blogPost,
          get: {
            ...state.blogPost.get,
            loading: true,
            reset: false,
            success: {
              ...state.blogPost.get.success,
              ok: false,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case actionTypes.GET_BLOG_POST_SUCCESS:
      return {
        ...state,
        blogPost: {
          ...state.blogPost,
          get: {
            ...state.blogPost.get,
            loading: false,
            reset: false,
            success: {
              ...state.blogPost.get.success,
              ok: true,
              data: action.payload,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case actionTypes.GET_BLOG_POST_FAIL:
      return {
        ...state,
        blogPost: {
          ...state.blogPost,
          get: {
            ...state.blogPost.get,
            loading: false,
            reset: false,
            success: {
              ...state.blogPost.get.success,
              ok: false,
              data: null,
            },
            failure: {
              error: true,
              errorCode: action.payload.code,
              message: action.payload.message,
              accessDenied: action.payload.accessDenied,
            },
          },
        },
      };
    case actionTypes.GET_BLOG_POST_RESET:
      return {
        ...state,
        blogPost: {
          ...state.blogPost.get,
          get: {
            ...INITIAL_STATE.blogPost.get,
            reset: true,
          },
        },
      };
    case actionTypes.GET_POST_COMMENTS_LOADING:
      return {
        ...state,
        comments: {
          ...state.comments,
          get: {
            ...state.comments.get,
            loading: true,
            reset: false,
            success: {
              ...state.comments.get.success,
              ok: false,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case actionTypes.GET_POST_COMMENTS_SUCCESS:
      return {
        ...state,
        comments: {
          ...state.comments,
          get: {
            ...state.comments.get,
            loading: false,
            reset: false,
            success: {
              ...state.comments.get.success,
              ok: true,
              data: action.payload,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case actionTypes.GET_POST_COMMENTS_FAIL:
      return {
        ...state,
        comments: {
          ...state.comments,
          get: {
            ...state.comments.get,
            loading: false,
            reset: false,
            success: {
              ...state.comments.get.success,
              ok: false,
              data: null,
            },
            failure: {
              error: true,
              message: action.payload.message,
              accessDenied: action.payload.accessDenied,
            },
          },
        },
      };
    case actionTypes.GET_POST_COMMENTS_RESET:
      return {
        ...state,
        comments: {
          ...state.comments.get,
          get: {
            ...INITIAL_STATE.comments.get,
            reset: true,
          },
        },
      };
    case actionTypes.GET_RELATED_BLOG_POSTS_LOADING:
      return {
        ...state,
        relatedBlogPosts: {
          ...state.relatedBlogPosts,
          get: {
            ...state.relatedBlogPosts.get,
            loading: true,
            reset: false,
            success: {
              ...state.relatedBlogPosts.get.success,
              ok: false,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case actionTypes.GET_RELATED_BLOG_POSTS_SUCCESS:
      return {
        ...state,
        relatedBlogPosts: {
          ...state.relatedBlogPosts,
          get: {
            ...state.relatedBlogPosts.get,
            loading: false,
            reset: false,
            success: {
              ...state.relatedBlogPosts.get.success,
              ok: true,
              data: action.payload,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case actionTypes.GET_RELATED_BLOG_POSTS_FAIL:
      return {
        ...state,
        relatedBlogPosts: {
          ...state.relatedBlogPosts,
          get: {
            ...state.relatedBlogPosts.get,
            loading: false,
            reset: false,
            success: {
              ...state.relatedBlogPosts.get.success,
              ok: false,
              data: null,
            },
            failure: {
              error: true,
              message: action.payload.message,
              accessDenied: action.payload.accessDenied,
            },
          },
        },
      };
    case actionTypes.GET_RELATED_BLOG_POSTS_RESET:
      return {
        ...state,
        relatedBlogPosts: {
          ...state.relatedBlogPosts.get,
          get: {
            ...INITIAL_STATE.relatedBlogPosts.get,
            reset: true,
          },
        },
      };
    case actionTypes.GET_LATEST_BLOG_POSTS_LOADING:
      return {
        ...state,
        latestBlogPosts: {
          ...state.latestBlogPosts,
          get: {
            ...state.latestBlogPosts.get,
            loading: true,
            reset: false,
            success: {
              ...state.latestBlogPosts.get.success,
              ok: false,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case actionTypes.GET_LATEST_BLOG_POSTS_SUCCESS:
      return {
        ...state,
        latestBlogPosts: {
          ...state.latestBlogPosts,
          get: {
            ...state.latestBlogPosts.get,
            loading: false,
            reset: false,
            success: {
              ...state.latestBlogPosts.get.success,
              ok: true,
              data: action.payload,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case actionTypes.GET_LATEST_BLOG_POSTS_FAIL:
      return {
        ...state,
        latestBlogPosts: {
          ...state.latestBlogPosts,
          get: {
            ...state.latestBlogPosts.get,
            loading: false,
            reset: false,
            success: {
              ...state.latestBlogPosts.get.success,
              ok: false,
              data: null,
            },
            failure: {
              error: true,
              message: action.payload.message,
              accessDenied: action.payload.accessDenied,
            },
          },
        },
      };
    case actionTypes.GET_LATEST_BLOG_POSTS_RESET:
      return {
        ...state,
        latestBlogPosts: {
          ...state.latestBlogPosts.get,
          get: {
            ...INITIAL_STATE.latestBlogPosts.get,
            reset: true,
          },
        },
      };
  }
  return state;
};

export default blogReducers;
